import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { PreviewToneRequest } from '../api/previewtone/previewtonerequest';
import { PreviewToneResponse, PreviewToneResponseDtoImpl } from '../api/previewtone/previewtoneresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { APIProcessorImpl } from './apiProcessor';
import { PreviewToneBuilder } from '../dto/previewtone/previewtonebuilder';
import { PreviewToneDtoImpl } from '../dto/previewtone/previewtonedto';

export class PreviewToneAPIProcessorImpl extends APIProcessorImpl<PreviewToneRequest, PreviewToneResponse>
{
    execute(request: PreviewToneRequest): void 
    {
        
    //    if(request.getPreviewToneRequest().getToneId() ===  this.getContext().getToneContext().getId())
    //    {
    //        let response = new PreviewToneResponseDtoImpl(APIFeatures.PREVIEW_TONE, "Preview Tone Success");
    //        this.getAPISuccess(response); 
    //    }
    //    else
    //    {
           super.execute(request);
    //    }
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new PreviewToneResponseDtoImpl(APIFeatures.PREVIEW_TONE, "Preview Tone Success");

                let previewToneDto = new PreviewToneDtoImpl();
                previewToneDto.setPreviewToneDetail(new PreviewToneBuilder(responseMapper.getResponseMap()).buildAll());

                this.getContext().setToneContext(previewToneDto.getPreviewToneDetail());

                response.setPreviewToneDto(previewToneDto);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new PreviewToneResponseDtoImpl(APIFeatures.PREVIEW_TONE, "No Preview Tone Data Available"));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new PreviewToneResponseDtoImpl(APIFeatures.PREVIEW_TONE, "Internal Server Error"));
            }
        }
        catch (e) {
            this.getAPIFailure(new PreviewToneResponseDtoImpl(APIFeatures.PREVIEW_TONE, "Internal Server Error"));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
            this.getAPIFailure(new PreviewToneResponseDtoImpl(APIFeatures.PREVIEW_TONE, responseMapper.getStatusMsg()));
        
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/previewtoneapiprocessor.tsx